import Vue from 'vue'
import Router from 'vue-router'
import $ from 'jquery'
import { homeRoute, routes } from '../router/routes'

Vue.use(Router)

let router = new Router({
  routes
})

router.beforeEach((to, from, next) => {
  const navbar = $(".navbar-collapse")

  if (navbar) {
    navbar.collapse("hide")
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (localStorage.getItem('token') == null) {
      next({
        path: '/auth',
        params: {
          nextUrl: to.fullPath
        }
      })
    } else {
      let user = JSON.parse(localStorage.getItem('user'))

      if (to.matched.some(record => record.meta.isAdmin)) {
        if (user.isAdmin == 1) {
          next()
        } else {
          next({
            name: homeRoute
          })
        }
      } else {
        if (to.matched.some(record => record.meta.roleRestricted)) {
          if (to.meta.roleRestricted.includes(user.role.name)) {
            let allowedRoutes = routes.filter(route => route.meta &&
              route.meta.requiresAuth &&
              (!route.meta.roleRestricted || !route.meta.roleRestricted.includes(user.role.name)))

            router.replace({
              name: allowedRoutes[0].name
            })
          } else {
            next()
          }
        } else {
          next()
        }
      }
    }
  } else if (to.matched.some(record => record.meta.guest)) {
    if (localStorage.getItem('token') == null) {
      next()
    } else {
      next({
        name: homeRoute
      })
    }
  } else {
    next()
  }
})

export default router